import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_baiv9uj7: FaireBrandEntity = {
  token: "b_baiv9uj7",
  type: "brand",
  name: "STACCATO",
  avatarUrl:
    "https://cdn.faire.com/fastly/5f29f3b552e7bc777814d25f1c55079c97b935b18f8e91dd9af5982394821420.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/fd0f80b88cb347d581d181f6456abdca74f390f718f2d5fcc0cf6be9ca906373.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5f29f3b552e7bc777814d25f1c55079c97b935b18f8e91dd9af5982394821420.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/fd0f80b88cb347d581d181f6456abdca74f390f718f2d5fcc0cf6be9ca906373.jpeg",
  location: "LOS ANGELES, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.7,
  reviewCount: 42,
  isInsider: true,
  description:
    "Established in 2005, Staccato is a Los Angeles based label creating clothes that are easy to layer and pair together. We focus on designing a beautiful range of basics, plaids, and knits, that you can effortlessly throw over your favorite pair of jeans so you can always be on the go. We believe the integration of classics and comfort should be a seamless effort for each and every piece of clothing.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:45.112Z",
    importedBy: "entity-db-cli",
  },
};
